module.exports = __webpack_public_path__ + "img/thumb-default-video.d781ee10.png";